<div style="background: var(--background);height: 100vh;padding: 0 40px">
  <div class="title-large" style="margin-bottom: 20px;padding-top: 40px">NPS</div>

  <div class="nps-summary-cards">
    <div class="nps-summary-card">
      <div class="card-label">Overall</div>
      <div class="card-value">{{ npsScore() }}</div>
      <div class="card-sub">{{ totalNps() }} responses</div>
    </div>
    <div class="nps-summary-card">
      <div class="card-label">Last 7 days</div>
      <div class="card-value">{{ nps7Days() }}</div>
      <div class="card-sub">{{ nps7DaysCount() }} responses</div>
    </div>
    <div class="nps-summary-card">
      <div class="card-label">Last 30 days</div>
      <div class="card-value">{{ nps30Days() }}</div>
      <div class="card-sub">{{ nps30DaysCount() }} responses</div>
    </div>
  </div>

  <div class="filter-controls mb-4">
    <div class="filter-group">
      <button (click)="applyFilter('All')" [class.active]="activeFilter() === 'All'">
        All
      </button>
      @for (filter of otherFilters; track filter) {
      <button (click)="applyFilter(filter)" [class.active]="activeFilter() === filter">
        {{ filter }}
      </button>
      }
    </div>
  </div>

  <table cdk-table [dataSource]="npsEntries()" class="nps-table">
    <!-- Date Column -->
    <ng-container cdkColumnDef="date">
      <th cdk-header-cell *cdkHeaderCellDef>Date</th>
      <td cdk-cell *cdkCellDef="let element">{{ element.date | date: 'dd MMM HH:mm' }}</td>
    </ng-container>

    <!-- Rating Column -->
    <ng-container cdkColumnDef="rating">
      <th cdk-header-cell *cdkHeaderCellDef>Rating</th>
      <td cdk-cell *cdkCellDef="let element">
        <div class="rating-container" [style.background-color]="getRatingColor(element.rating)">
          {{ element.rating }}
        </div>
      </td>
    </ng-container>

    <!-- Feedback Column -->
    <ng-container cdkColumnDef="feedback">
      <th cdk-header-cell *cdkHeaderCellDef>Feedback</th>
      <td cdk-cell *cdkCellDef="let element" class="feedback-cell">
        {{ element.feedback }}
        @if (element.subscription !== 'Drop in') {
        <span class="user-chip" (click)="navigateToDynamics(element.uid)">
          {{ element.uid }}
          <svg class="copy-icon" viewBox="0 0 24 24" width="12" height="12">
            <path d="M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z" fill="currentColor"/>
          </svg>
        </span>
        } @else if (element.email) {
        <span class="user-chip" (click)="copyToClipboard(element.email)">
          {{ element.email }}
          <svg class="copy-icon" viewBox="0 0 24 24" width="12" height="12">
            <path
              d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"
              fill="currentColor" />
          </svg>
        </span>
        } @else if (element.lastSavedContactId) {
        <span class="user-chip" (click)="navigateToDynamics(element.lastSavedContactId)">
          {{ element.lastSavedContactId }}
          <svg class="copy-icon" viewBox="0 0 24 24" width="12" height="12">
            <path d="M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z" fill="currentColor"/>
          </svg>
        </span>
        }
      </td>
    </ng-container>

    <!-- OS Column -->
    <ng-container cdkColumnDef="os">
      <th cdk-header-cell *cdkHeaderCellDef>OS</th>
      <td cdk-cell *cdkCellDef="let element">{{ element.os }}</td>
    </ng-container>

    <!-- App Version Column -->
    <ng-container cdkColumnDef="appVersion">
      <th cdk-header-cell *cdkHeaderCellDef>Version</th>
      <td style="text-wrap: nowrap" cdk-cell *cdkCellDef="let element">{{ element.appVersion }}</td>
    </ng-container>

    <!-- Subscription Column -->
    <ng-container cdkColumnDef="subscription">
      <th cdk-header-cell *cdkHeaderCellDef>User</th>
      <td cdk-cell *cdkCellDef="let element">{{ element.subscription }}</td>
    </ng-container>

    <!-- Contact Column -->
    <ng-container cdkColumnDef="canContact">
      <th cdk-header-cell *cdkHeaderCellDef style="width: 1%; text-align: center">Contact</th>
      <td cdk-cell *cdkCellDef="let element" style="text-align: center">
        @if (element.canContact) {
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12 1C5.928 1 1 5.928 1 12C1 18.072 5.928 23 12 23C18.072 23 23 18.072 23 12C23 5.928 18.072 1 12 1ZM17.566 9.327L10.977 15.916C10.801 16.092 10.581 16.169 10.35 16.169C10.119 16.169 9.899 16.081 9.723 15.916L6.434 12.627C6.093 12.286 6.093 11.725 6.434 11.373C6.775 11.032 7.336 11.032 7.688 11.373L10.35 14.035L16.312 8.073C16.653 7.721 17.214 7.721 17.555 8.073C17.896 8.414 17.896 8.975 17.555 9.327H17.566Z"
            fill="#0000C8" />
        </svg>

        }
      </td>
    </ng-container>

    <tr cdk-header-row *cdkHeaderRowDef="displayedColumns"></tr>
    <tr cdk-row *cdkRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <div style="text-align: right">
    <button style="padding: 0;background: transparent;color: #0000A6" (click)="downloadCsv()">Download CSV</button>
  </div>


  <div class="paginator">
    <button (click)="previousPage()" [disabled]="currentPage() === 1" class="paginator-button">
      <svg width="6" height="10" viewBox="0 0 6 10" xmlns="http://www.w3.org/2000/svg">
        <path d="M5.835 0.885L4.95 0L0 4.95L4.95 9.9L5.835 9.015L1.77 4.95L5.835 0.885Z" />
      </svg>
    </button>

    <span style="width: 200px;text-align: center">Page {{ currentPage() }} of {{ totalPages() }}</span>

    <button (click)="nextPage()" [disabled]="currentPage() === totalPages()" class="paginator-button">
      <svg width="6" height="10" viewBox="0 0 6 10" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M-3.86755e-05 9.01539L0.884961 9.90039L5.83496 4.95039L0.884962 0.000390574L-3.79647e-05 0.885391L4.06496 4.95039L-3.86755e-05 9.01539Z" />
      </svg>
    </button>
  </div>
</div>